import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthService } from './_services/auth.service';
import { AuthGuard } from './_guards/auth.guard';
import { DomainGuard } from './_guards/domain.guard';
import { ApiInterceptor } from './_interceptors/api.interceptor';
import {SidemenuComponent} from './ui/sidemenu/sidemenu.component';

@NgModule({
  declarations: [AppComponent, SidemenuComponent],
  entryComponents: [],
  imports: [
    HttpClientModule,
    BrowserModule,
    IonicModule.forRoot({ swipeBackEnabled: false }),
    AppRoutingModule,
    BrowserAnimationsModule],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    AuthService,
    AuthGuard,
    DomainGuard],
  bootstrap: [AppComponent],
})
export class AppModule {
}
